export var SourceType;
(function (SourceType) {
    SourceType["FUNNEL"] = "funnel";
    SourceType["WEBSITE"] = "website";
    SourceType["INVOICE"] = "invoice";
    SourceType["CALENDAR"] = "calendar";
    SourceType["TEXT2PAY"] = "text2Pay";
    SourceType["MEMBERSHIP"] = "membership";
    SourceType["MOBILE_APP"] = "mobile_app";
    SourceType["COMMUNITIES"] = "communities";
    SourceType["POINT_OF_SALE"] = "point_of_sale";
    SourceType["MANUAL"] = "manual";
    SourceType["FORM"] = "form";
    SourceType["SURVEY"] = "survey";
    SourceType["PAYMENT_LINK"] = "payment_link";
    SourceType["EXTERNAL"] = "external";
})(SourceType || (SourceType = {}));
export var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType["STRIPE"] = "stripe";
    PaymentProviderType["PAYPAL"] = "paypal";
    PaymentProviderType["MANUAL"] = "manual";
    PaymentProviderType["AUTHORIZE_NET"] = "authorize-net";
    PaymentProviderType["NMI"] = "nmi";
})(PaymentProviderType || (PaymentProviderType = {}));
export var ChargeCardType;
(function (ChargeCardType) {
    ChargeCardType["NEW_CARD"] = "newCard";
    ChargeCardType["SAVED_CARDS"] = "savedCards";
})(ChargeCardType || (ChargeCardType = {}));
export class PaymentLinks {
    linkName;
    liveMode;
    active;
    createdAt;
    products;
}
